import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, type Ref, ComputedRef } from 'vue';
import { JSX } from 'vue/jsx-runtime';

import { useAuthStore, useFilterStore, useUiStore } from '@/stores';
import {
    TemplateHeader,
    TemplateSidebar,
    TemplateNavigation,
    TemplateProfile,
} from '@/views/templates/components';

import { LevelModel, NavigationItem, CompanyModel } from '@/types';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { SelectOptionsServiceGetLevelsResult } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTemplate',
  props: {
    navigationItems: { type: Array, required: true },
    headerActions: { type: Function, required: false },
    title: { type: String, required: false },
    routerKey: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();



const uiStore = useUiStore();
const filterStore = useFilterStore();

const levelOptions: Ref<SelectOptionsServiceGetLevelsResult[]> = ref([]);

const logoPath = computed(() => {
    const authStore = useAuthStore();
    const company: ComputedRef<CompanyModel | undefined> = computed(() => authStore.userCompany);
    return company.value?.templateLogo || '/img/logo-mob.png';
});

const loading = computed(() => uiStore.isLoading);

const isLevelLocked = computed(() => uiStore.isLevelLocked);

const levelFilter = computed<LevelModel | null>({
    get: () => filterStore.level,
    set: (level: LevelModel) => filterStore.setLevel(level),
});

const headerClass = computed(() => {
    if (process.env.NODE_ENV === 'production') return 'bg-slate-100';
    if (process.env.NODE_ENV === 'development') return 'bg-teal-700';
    return 'bg-gray-700';
});

const fetchLevels = async () => {
    try {
        const { data } = await SelectOptionsService.getLevels();
        levelOptions.value = data;
    } catch (err) {
        toastServiceError(err);
    }
};

onMounted(async () => {
    await fetchLevels();
});

const __returned__ = { uiStore, filterStore, levelOptions, logoPath, loading, isLevelLocked, levelFilter, headerClass, fetchLevels, get TemplateHeader() { return TemplateHeader }, get TemplateSidebar() { return TemplateSidebar }, get TemplateNavigation() { return TemplateNavigation }, get TemplateProfile() { return TemplateProfile } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})